import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { ConfidenceBars } from '~/components/RevenueOpportunities/ConfidenceBars/ConfidenceBars';
const confidenceBarsOf = (testId)=>(row)=>[
            {
                icon: ()=>/*#__PURE__*/ _jsx(ConfidenceBars, {
                        band: row.confidenceBand,
                        label: row.confidenceLabel,
                        testId: testId(row.id)
                    }),
                tooltip: row.confidenceLabel
            }
        ];
export const seeAllTable = (texts, isMobileDevice, confidenceBarsTestId)=>{
    const confidenceBars = confidenceBarsOf(confidenceBarsTestId);
    const confidenceLook = {
        header: texts.columns.confidence(),
        sortable: true,
        bi: {
            name: 'pulse_see_all_sort_confidence'
        },
        hAlign: 'end',
        width: {
            floorSample: texts.columns.confidence(),
            hug: true
        },
        indicators: confidenceBars
    };
    return {
        mainColumn: {
            type: 'text',
            name: 'client',
            header: texts.columns.client(),
            sortable: true,
            bi: {
                name: 'pulse_see_all_sort_client'
            }
        },
        columns: [
            {
                type: 'text',
                name: 'type',
                header: texts.columns.type(),
                sortable: true,
                bi: {
                    name: 'pulse_see_all_sort_type'
                }
            },
            {
                type: 'text',
                name: 'service',
                header: texts.columns.service(),
                sortable: true,
                bi: {
                    name: 'pulse_see_all_sort_service'
                }
            },
            isMobileDevice ? _object_spread_props(_object_spread({}, confidenceLook), {
                type: 'text',
                name: 'confidenceLabel'
            }) : _object_spread_props(_object_spread({}, confidenceLook), {
                type: 'indicators',
                name: 'confidence'
            }),
            {
                type: 'text',
                name: 'value',
                header: texts.columns.yearlyValue(),
                sortable: true,
                bi: {
                    name: 'pulse_see_all_sort_value'
                },
                hAlign: 'end'
            }
        ],
        mobileCard: {
            fields: [
                {
                    name: 'type',
                    joinWith: 'service'
                },
                {
                    name: 'confidenceLabel'
                },
                {
                    name: 'value',
                    label: texts.columns.yearlyValue()
                }
            ]
        }
    };
};
